import React from "react";

const LoadingScreen = () => {
  return (
    <div className="divColumn">
      <img src={"/icons/icon_checkmark.png"} />
      <div className="textBold" style={{ fontSize: "25px" }}>
        CheckOnMe is loading
      </div>
    </div>
  );
};

export default LoadingScreen;
